export { default } from './CustomDetailList';